(() => {
  document.querySelectorAll('[data-faiz-card-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('.faiz-product__slide'));
    const previousButton = gallery.querySelector('[data-faiz-gallery-prev]');
    const nextButton = gallery.querySelector('[data-faiz-gallery-next]');
    const dotsContainer = gallery.querySelector('[data-faiz-gallery-dots]');
    const mediaLink = gallery.querySelector('.faiz-product__media-link');

    if (slides.length < 2) {
      previousButton?.setAttribute('hidden', '');
      nextButton?.setAttribute('hidden', '');
      dotsContainer?.setAttribute('hidden', '');
      return;
    }

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let pointerStartX = 0;
    let pointerDistance = 0;
    let pointerActive = false;

    const show = (nextIndex) => {
      const normalizedIndex = (nextIndex + slides.length) % slides.length;
      slides[activeIndex].classList.remove('is-active');
      slides[activeIndex].setAttribute('aria-hidden', 'true');
      dots[activeIndex]?.removeAttribute('aria-current');
      activeIndex = normalizedIndex;
      slides[activeIndex].classList.add('is-active');
      slides[activeIndex].removeAttribute('aria-hidden');
      dots[activeIndex]?.setAttribute('aria-current', 'true');
    };

    const dots = slides.map((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'faiz-product__gallery-dot';
      dot.setAttribute('aria-label', `Afficher la photo ${index + 1}`);
      dot.addEventListener('click', () => show(index));
      dotsContainer?.appendChild(dot);
      return dot;
    });

    previousButton?.addEventListener('click', () => show(activeIndex - 1));
    nextButton?.addEventListener('click', () => show(activeIndex + 1));
    dots[activeIndex]?.setAttribute('aria-current', 'true');

    mediaLink?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(activeIndex + 1);
      }
    });

    mediaLink?.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
      pointerDistance = 0;
      pointerActive = true;
    });

    mediaLink?.addEventListener('pointermove', (event) => {
      if (!pointerActive) return;
      pointerDistance = event.clientX - pointerStartX;
    });

    mediaLink?.addEventListener('pointerup', () => {
      if (!pointerActive) return;
      pointerActive = false;
      if (Math.abs(pointerDistance) < 38) return;
      show(pointerDistance < 0 ? activeIndex + 1 : activeIndex - 1);
    });

    mediaLink?.addEventListener('pointercancel', () => {
      pointerActive = false;
      pointerDistance = 0;
    });

    mediaLink?.addEventListener('click', (event) => {
      if (Math.abs(pointerDistance) >= 38) event.preventDefault();
      pointerDistance = 0;
    });
  });
})();
